import BasicModel from '../basic/BasicModel'
export default {

  getCdChannelProvince(vm, params, listener) {
    let action = 'carShow/carShowInfo/getCdChannelProvince.action'
    BasicModel.get(vm, action, params, listener)
  },
  getcdChannel(vm, params, listener) {
    let action = 'carShow/carShowInfo/getcdChannel.action'
    BasicModel.get(vm, action, params, listener)
  },
  addCsSHowChannel(vm, params, listener) {
    let action = 'carShow/carShowInfo/addCsSHowChannel.action'
    BasicModel.post(vm, action, params, listener)
  },
  addExclusiveCsSHowChannel(vm, params, listener) {
    let action = 'carShow/carShowInfo/addExclusiveCsSHowChannel.action'
    BasicModel.post(vm, action, params, listener)
  },
  updateChannelSwitch(vm, params, listener) {
    let action = 'carShow/carShowInfo/updateChannelSwitch.action'
    BasicModel.post(vm, action, params, listener)
  },
  checkChannelName(vm, params, listener) {
    let action = 'carShow/carShowInfo/checkChannelName.action'
    BasicModel.post(vm, action, params, listener)
  },


}
